/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Versicherungsstatus1Inputs */



/**

* @param {_Field_Versicherungsstatus1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_versicherungsstatus1 = /** @type {((inputs?: _Field_Versicherungsstatus1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Versicherungsstatus1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Krankenversicherungsstatus")
});
export { _field_versicherungsstatus1 as "_field_versicherungsStatus" }